import React  from 'react';
import { Box, Button, MenuItem, FormControl, InputLabel, Select, TextField } from "@mui/material";
import { Autorenew, Delete, SelectAll } from "@mui/icons-material";
import {colorEasyRed, colorIcon, colorSecondary, mobileButton} from "../App/theme.js";
import {  isMobile } from "../App/utils.js";
import {detectTypes} from "./utils";
import {initDB} from "../Engines/Dexie";
import {useConfirm} from "../Components/ConfirmContext";


const propToType = (str) => str.replace(/\d+$/, '');

export const BaseTools = ({
    setSelectMode, embeddingConfigured, setDevMode, selectedItems, items, handleDeleteSelected, exclusiveStartKeyHistory,
    handleLimitChange, handleNextPage, handlePreviousPage, selectMode, devMode, limit, lastEvaluatedKey, FetchItems,
    setFrom, setTo, setField, field, from, to, stores, store, setStore, isIndexedDB, index, setIndex, itemsIndexedDB,
    KBData, setSystemAlert, setLoading
}) => {

    const selectedStore = stores?.find(o => o.name === store);

    const myItems = itemsIndexedDB || items;

    const attributes = KBData?.itemTypes?.[store]?.attributes;

    const selectedAttribute = attributes?.find(a => a.attrName === index);

    let attrType = selectedAttribute ? propToType(selectedAttribute.attrType) : undefined;

    const handleDateChange = (setter) => (e) => {
        const date = new Date(e.target.value).getTime();
        setter(parseInt(date));
    };

    const showConfirm = useConfirm();

    let {isNumber, isBoolean, isDate, isDateTime, isString} = detectTypes({ isIndexedDB, attrType, index, field })

    const parseDate = (value) => {
        try {
            return new Date(value).toISOString().slice(0, -1)
        } catch (e) {
            return ''
        }
    }
    return (
        <>
            <Box display="flex" flexDirection={isMobile ? 'column' : 'row'} justifyContent="space-between">
                <Box mt={1} mb={2} display="flex" flexDirection="row" justifyContent="space-between">
                    <Button
                        variant="text"
                        color={selectMode ? 'secondary' : 'primary'}
                        sx={{ marginRight: 2, width: 160, height: 40 }}
                        startIcon={<SelectAll style={{ color: selectMode ? colorSecondary : colorIcon }} />}
                        onClick={() => setSelectMode(!selectMode)}
                    >
                        {isMobile ? 'Bulk' : 'Bulk Actions'}
                    </Button>

                    {KBData?.searchEngine === 'IndexedDB' && <Button
                        variant="text"
                        color={'error2'}
                        sx={{ marginRight: 2, width: 160, height: 40 }}
                        startIcon={<Autorenew style={{ color: colorEasyRed }} />}
                        onClick={async () => {
                            const confirmed = await showConfirm({
                                title: 'Reindex All Data Confirmation',
                                content: 'Are you sure you want to reindex all database items?'
                            })

                            if (confirmed) {
                                indexedDB.deleteDatabase('IndexedDB_' + KBData.kbId).onsuccess = () => {
                                    localStorage.removeItem('IndexedDB')
                                    initDB({KBData, setSystemAlert, setLoading}).then((db) => {
                                        window.location.reload()
                                    });
                                };

                            }
                        }}
                    >
                        {isMobile ? 'Reindex Data' : 'Reindex Data'}
                    </Button>}

                    {selectMode && myItems && myItems.length > 0 && selectedItems.length !== 0 && (
                        <Button
                            variant="text"
                            sx={{ marginRight: 2, height: 40 }}
                            color={selectedItems.length === 0 ? 'primary' : 'secondary'}
                            startIcon={<Delete fontSize="small" style={{ marginLeft: 0, color: (selectedItems.length !== 0 ? colorSecondary : colorIcon) }} />}

                            onClick={handleDeleteSelected}
                            disabled={selectedItems.length === 0}
                        >
                            {isMobile ? '' : ' Delete '}{selectedItems.length ? selectedItems.length + ' ' : ''}{isMobile ? '' : ' Selected '}
                        </Button>
                    )}

                    {/*<Button*/}
                    {/*    variant="text"*/}
                    {/*    sx={{ marginRight: 2, width: 140, height: 40, textTransform: 'none' }}*/}

                    {/*    color={devMode ? 'secondary' : 'primary'}*/}
                    {/*    startIcon={<ArrowDropDown style={{ color: devMode ? colorSecondary : colorIcon }} />}*/}
                    {/*    onClick={() => setDevMode((prevDevMode) => !prevDevMode)}*/}
                    {/*>*/}
                    {/*    {isMobile ? 'Query' : 'Query'}*/}
                    {/*</Button>*/}
                </Box>

                {embeddingConfigured && !!myItems?.length && (
                    <Box mt={1} mb={2} display="flex" flexDirection="row" justifyContent="space-between">
                        <Button variant="outlined" color="primary" onClick={handlePreviousPage}
                                sx={{ marginRight: 2, width: 100, height: 40, visibility: (isIndexedDB || exclusiveStartKeyHistory.length === 0) ? 'hidden' : undefined }}
                                disabled={exclusiveStartKeyHistory.length === 0}>
                            Previous
                        </Button>
                        <FormControl variant="outlined" sx={{ minWidth: 100, mb: 2 }}>
                            <InputLabel id="limit-select-label" size={"small"}>Limit</InputLabel>
                            <Select
                                labelId="limit-select-label"
                                value={limit || ''}
                                onChange={handleLimitChange}
                                label="Limit"
                                size={"small"}
                            >
                                {[undefined, 25, 50, 100, 500, 1000, 5000, 10000, 50000].map(value => (
                                    <MenuItem key={value || 'noLimit'} value={value}>
                                        {value === undefined ? 'Initial Set' : value}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <Button variant="outlined" color="primary" onClick={handleNextPage}
                                sx={{ marginLeft: 2, width: 100, height: 40, visibility: (isIndexedDB || !lastEvaluatedKey) ? 'hidden' : undefined }}
                                disabled={!lastEvaluatedKey}>
                            Next
                        </Button>
                    </Box>
                )}
            </Box>

            {devMode && (
                <Box
                    display="flex"
                    flexDirection={isMobile ? 'column' : 'row'}
                    justifyContent="space-between"
                    mb={1}
                >
                    {isIndexedDB && stores && <FormControl
                        variant="outlined"
                        sx={{ width: isMobile ? '100%' : '20%', mb: 2 }}
                    >
                        <InputLabel id="store-select-label">Type</InputLabel>
                        <Select
                            value={store}
                            onChange={(e) => setStore(e.target.value)}
                            label="Type"
                            sx={{ maxHeight: 40 }}
                        >
                            {stores.map((value) => (
                                <MenuItem key={value.name} value={value.name}>
                                    {value.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>}

                    {isIndexedDB && stores && <FormControl
                        variant="outlined"
                        sx={{ width: isMobile ? '100%' : '20%', mb: 2 }}
                    >
                        <InputLabel id="index-select-label">Index</InputLabel>
                        <Select
                            value={index}
                            onChange={(e) => setIndex(e.target.value)}
                            label="Index"
                            sx={{ maxHeight: 40 }}
                        >
                            {[...(selectedStore?.indexes?.includes('itemId') ? selectedStore.indexes : ['itemId', ...selectedStore.indexes])].map((value) => {
                                const attribute = attributes?.find(a => a.attrName === value);
                                if (value === 'embeddingModel') return null;

                                return (
                                    <MenuItem key={value} value={value} disabled={attribute?.encrypted}>
                                        {value} {attribute?.encrypted ? ' (encrypted)' : ''}
                                    </MenuItem>
                                );
                            })}
                        </Select>
                    </FormControl>}

                    {!isIndexedDB && <FormControl
                        variant="outlined"
                        sx={{ width: isMobile ? '100%' : '20%', mb: 2 }}
                    >
                        <InputLabel id="field-select-label">Index</InputLabel>
                        <Select
                            value={field}
                            onChange={(e) => setField(e.target.value)}
                            label="Index"
                            sx={{ maxHeight: 40 }}
                        >
                            {['itemId', 'updatedAt'].map((value) => (
                                <MenuItem key={value} value={value}>
                                    {value}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>}

                    {isString && (<>
                        <TextField
                            label={"startsWith"}
                            size={"small"}
                            placeholder="startsWith"
                            variant="outlined"
                            value={from || ''}
                            sx={{ mb: 2, ml: 1, width: isMobile ? '100%' : '20%' }}
                            onChange={(e) => setFrom(e.target.value?.toString())}
                            InputProps={{ sx: { height: 40 } }}
                        />
                        <TextField
                            sx={{ mb: 2, width: isMobile ? '100%' : '20%', visibility: 'hidden' }}
                            InputProps={{ sx: { height: 40 } }}
                        />

                    </>)}

                    {isNumber && (
                        <>
                            <TextField
                                size={"small"}
                                label={"From"}
                                placeholder="From"
                                variant="outlined"
                                value={from || ''}
                                sx={{ mb: 2, width: isMobile ? '100%' : '20%' }}
                                onChange={(e) => setFrom(parseFloat(e.target.value))}
                                InputProps={{ sx: { height: 40 } }}
                            />
                            <TextField
                                size={"small"}
                                placeholder="To"
                                label={"To"}
                                variant="outlined"
                                value={to || ''}
                                sx={{ mb: 2, width: isMobile ? '100%' : '20%', visibility: !isNumber ? 'hidden' : undefined}}
                                onChange={(e) => setTo(parseFloat(e.target.value))}
                                InputProps={{ sx: { height: 40 } }}
                            />
                        </>
                    )}

                    {(isDate || isDateTime) && (
                        <>
                            <TextField
                                size={"small"}
                                label={"From"}
                                type="datetime-local"
                                variant="outlined"
                                value={from ? parseDate(from) : ''}
                                sx={{ mb: 2, width: isMobile ? '100%' : '20%' }}
                                onChange={handleDateChange(setFrom)}
                                InputProps={{ sx: { height: 40 } }}
                            />
                            <TextField
                                size={"small"}
                                label={"To"}
                                type="datetime-local"
                                variant="outlined"
                                value={to ? parseDate(to) : ''}
                                sx={{ mb: 2, width: isMobile ? '100%' : '20%' }}
                                onChange={handleDateChange(setTo)}
                                InputProps={{ sx: { height: 40 } }}
                            />
                        </>
                    )}

                    {FetchItems && (
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={FetchItems}
                            sx={{ mb: 2, maxHeight: 40, width: isMobile ? '100%' : '20%', ...mobileButton, marginTop: 0 }}
                        >
                            Search
                        </Button>
                    )}
                </Box>
            )}
        </>
    );
}
